<template>
  <v-btn
    x-large
    class="custom-button"
    @click="$emit('click')"
  >
    <span class="px-1">{{ text }}</span>
  </v-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>